import React, { useState } from 'react'

// styles
import { TooltipWrapper, TooltipTip } from './styles'

// Load components synchronously
import ConditionalDisplay from 'components/ConditionalDisplay/ConditionalDisplay'

const Tooltip = props => {
  const {
    cursor,
    displayBlock,
    displayFlex,
    forceShow,
    forceShowOnLoad,
    height,
    isWarning,
    translateX,
    translateY,
    useAutoWidth
  } = props
  if (!props.content) {
    return props.children
  }

  const [active, setActive] = useState(forceShowOnLoad || false)

  const forceShowTip = () => {
    if (forceShow) {
      setActive(true)
    }
  }

  const showTip = () => {
    setActive(true)
  }

  const hideTip = () => {
    const hideTipTimeout = forceShow ? 0 : 2000
    setTimeout(() => {
      setActive(false)
    }, hideTipTimeout)
  }

  return (
    <TooltipWrapper
      cursor={cursor}
      displayBlock={displayBlock}
      displayFlex={displayFlex}
      height={height}
      onClick={showTip}
      onTouchEnd={showTip}
      onMouseLeave={hideTip}
      onMouseEnter={forceShowTip}
      position={props.position}
    >
      {props.children}

      <ConditionalDisplay displayWhen={[active]}>
        <TooltipTip
          isWarning={isWarning}
          onClick={hideTip}
          position={props.position}
          tinyTooltip={props.tinyTooltip}
          translateX={translateX}
          translateY={translateY}
          useAutoWidth={useAutoWidth}
        >
          {props.content}
        </TooltipTip>
      </ConditionalDisplay>
    </TooltipWrapper>
  )
}

export default Tooltip
